module.exports = __webpack_public_path__ + "static/media/doctor.d2a6cba2.svg";